import { Space } from "antd";
import { OrderHoursAndJoin } from "~/utils/date";
import { DAYS_OF_WEEK_DB } from "~/utils";

interface DayAndHourRange {
    day: string;
    startTime: string;
    endTime: string;
}

/**
 * This function converts the day-time string to an array of DayAndHourRanges.
 * @param hoursString the day-time string to be converted, should be in the format X-aa:aa-bb:bb
 * where X is one or more days of the week (aka some combination of the letters UMTWHFA),
 * aa:aa is the start time (format hh:mm), and bb:bb is the end time (format hh:mm).
 * @returns the input string as an array of DayAndHourRanges.
 */
const GetHoursByDay = (hoursString: string): DayAndHourRange[] => {
    const hoursStringSplit: string[] = hoursString?.split("-");
    let result: DayAndHourRange[] = [];

    // The same times need to be added for each day of the week in the hoursString.
    for (let i = 0; i < hoursStringSplit[0].length; i++) {
        result.push({ day: hoursStringSplit[0][i], startTime: hoursStringSplit[1], endTime: hoursStringSplit[2] });
    }

    return result;
};

export const FormattedHoursTag = (hoursStringSet: (string | null)[]): JSX.Element => {
    let hoursByDay: string[][] = [[], [], [], [], [], [], []];
    for (let i = 0; i < hoursStringSet.length; i++) {
        if (hoursStringSet[i]) {
            const dayAndHourRanges: DayAndHourRange[] = GetHoursByDay(hoursStringSet[i] ?? "");
            for (let j = 0; j < dayAndHourRanges.length; j++) {
                let dayIndex: number;
                switch (dayAndHourRanges[j].day) {
                    case DAYS_OF_WEEK_DB.sunday:
                        dayIndex = 0;
                        break;
                    case DAYS_OF_WEEK_DB.monday:
                        dayIndex = 1;
                        break;
                    case DAYS_OF_WEEK_DB.tuesday:
                        dayIndex = 2;
                        break;
                    case DAYS_OF_WEEK_DB.wednesday:
                        dayIndex = 3;
                        break;
                    case DAYS_OF_WEEK_DB.thursday:
                        dayIndex = 4;
                        break;
                    case DAYS_OF_WEEK_DB.friday:
                        dayIndex = 5;
                        break;
                    case DAYS_OF_WEEK_DB.saturday:
                        dayIndex = 6;
                        break;
                    default:
                        dayIndex = -1;
                        break;
                }

                if (dayIndex !== -1) {
                    hoursByDay[dayIndex].push(`${dayAndHourRanges[j].startTime} - ${dayAndHourRanges[j].endTime}`);
                }
            }
        }
    }

    return (
        <Space direction="vertical">
            {`Sunday: ${OrderHoursAndJoin(hoursByDay[0])}`}
            {`Monday: ${OrderHoursAndJoin(hoursByDay[1])}`}
            {`Tuesday: ${OrderHoursAndJoin(hoursByDay[2])}`}
            {`Wednesday: ${OrderHoursAndJoin(hoursByDay[3])}`}
            {`Thursday: ${OrderHoursAndJoin(hoursByDay[4])}`}
            {`Friday: ${OrderHoursAndJoin(hoursByDay[5])}`}
            {`Saturday: ${OrderHoursAndJoin(hoursByDay[6])}`}
        </Space>
    );
};